$(function() {
  $('.select-picker').selectpicker({
    style: 'btn-outline p-2'
  });
});

// document.addEventListener("turbolinks:before-cache", function () {
//   $(".select-picker").selectpicker('destroy');
// });